export default "__VITE_ASSET__d26066aa__"